import React, { Fragment, useState, useEffect } from 'react'
import { handleLongText } from 'config/libraries';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const ServiceList = ({response}) => {
    const [IsLoading, setIsLoading] = useState(false);
    const [CurrentDataResponse, setCurrentDataResponse] = useState(null);
    const [RadioResponse, setRadioResponse] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    
    useEffect(() => {
        handleGetRadio()
    }, [])

    function handleShow(data) {
        setCurrentDataResponse(data)
        setShow(true);
    }

    const handleGetRadio = () => {
        setIsLoading(false)
        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/kategori-layanan-online').then(function (res) {
            console.log('res', res)
            setRadioResponse(res.data.data)
        }).catch(function (error) {

        }).finally(function () {
            setIsLoading(true)
        })
    };

    return (
        <div className="row p-4">
            {
                RadioResponse && RadioResponse.map((item, index) => {

                    // let filename = item.file_informasi.split('.').pop();
                    // if (filename === 'jpg' || filename === 'png' || filename === 'jpeg' || filename === 'svg' || filename === 'webp') {
                    //     // item.file_informasi = 'https://png.pngtree.com/element_our/20190528/ourlarge/pngtree-file-icon-image_1128287.jpg'
                    // } else {
                    //     item.file_informasi = 'https://png.pngtree.com/element_our/20190528/ourlarge/pngtree-file-icon-image_1128287.jpg'
                    // }
                    
                    return (
                        <div key={index} className="col-xl-4 col-md-6">
                            {/* <div onClick={() => handleShow(item)} className="service-item cursor-pointer wow fadeInUp delay-0-2s" style={{visibility: 'visible', animationName: 'fadeInUp'}}> */}
                            <Link to={'/form-detail/' + item.slug_kategori + '?name=' + item.nama_kategori} className="service-item cursor-pointer wow fadeInUp delay-0-2s" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                                <i className="flaticon-file" />
                                <div className="content">
                                    {/* <h3><a href="#!">Layanan {index + 1}</a></h3> */}
                                    <h3><a href="#!">{item.nama_kategori}</a></h3>
                                    <p>{handleLongText(item.keterangan, 50)}</p>
                                </div>
                            </Link>
                        </div>
                    )
                })
            }
            <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Detail Informasi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        (CurrentDataResponse != null ? 
                            <Fragment>
                                <h5 className='mb-4'>{CurrentDataResponse.judul_informasi}</h5>
                                <div className='' dangerouslySetInnerHTML={{__html: CurrentDataResponse.konten_informasi}}></div>
                            </Fragment>
                            : '')
                    }
                    
                </Modal.Body>
                <Modal.Footer>
                    {
                        (CurrentDataResponse != null ? 
                            (CurrentDataResponse.file_informasi.includes('http')) ?
                            <a href={CurrentDataResponse.file_informasi} target="_blank" rel="noreferrer" className='btn btn-primary' variant="primary" onClick={handleClose}>
                                Unduh File
                            </a> : 
                            <a href={process.env.REACT_APP_SERVER_IMAGE_URL + CurrentDataResponse.file_informasi} target="_blank" rel="noreferrer" className='btn btn-primary' variant="primary" onClick={handleClose}>
                                Unduh File
                            </a> 
                        : '' )
                    }
                </Modal.Footer>
            </Modal>
        </div>
    )
};